import React, { useSyncExternalStore } from "react";
import { AnimatePresence } from "framer-motion";
import Toast from "./Toast";
import { subscribe, getToasts, dismissToast } from "./toastStore";

// Single mount point for the toast stack. Render once near the app root
// (see src/index.js). Subscribes to the module-level store and renders the
// design-system <Toast/> for each active toast, newest at the top.
//
// The container owns the fixed positioning + stacking; each <Toast/> renders in
// `stacked` mode so it flows inside the column instead of self-positioning.
// `tw-z-[1400]` sits above MUI dialogs (1300) so toasts are never hidden behind
// a modal. The container is click-through (pointer-events-none); each toast
// re-enables pointer events for its close button.
const Toaster = () => {
  const toasts = useSyncExternalStore(subscribe, getToasts, getToasts);

  return (
    <div className="tw-pointer-events-none tw-fixed tw-top-0 tw-right-0 tw-z-[1400] tw-flex tw-flex-col-reverse tw-gap-2 tw-p-4">
      <AnimatePresence>
        {toasts.map((t) => (
          <div key={t.id} className="tw-pointer-events-auto">
            <Toast stacked message={t.message} type={t.type} onClose={() => dismissToast(t.id)} />
          </div>
        ))}
      </AnimatePresence>
    </div>
  );
};

export default Toaster;
